const cssNotesModalBodyHtml = require("./html/cssNotesModalBody.html");
const cssReadNotesModalBodyHtml = require("./html/cssReadNotesModalBody.html");
const editErrorOrderModal = require("./html/editErrorOrderModal.html");
const editBackOrderedOrderModal = require("./html/editBackOrderedOrderModal.html");
const editHeldOrderModal = require("./html/editHeldOrderModal.html");
const editCustomHeldOrderModal = require("./html/editCustomHeldOrderModal.html");
const editChannelHeldOrderModal = require("./html/editChannelHeldOrderModal.html");
const editPortalHeldOrderModal = require("./html/editPortalHeldOrderModal.html");
const modalHtml = require("../../sharedHtml/modal.html");
import render from "./../../utilities/render";
import run from '../../utilities/run';
import detailAddressValidation from './detailAddressValidation.js';
import shipFedExModalFactory from "./components/shipFedExModal/shipFedExModal";
import shipThirdPartyModalFactory from "./components/shipThirdPartyModal/shipThirdPartyModal";
import $ from 'jquery';
import moment from "moment";
import {isPresent, getESTDate} from "../../utilities/general";
require("../stubs/orderDetailStub/orderDetailStub.less");
const _ = require("underscore");
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";
import {shallAllowClick} from "../../utilities/general";
import {doAjax} from "../../utilities/filtersutil";
import PagableComponent from "../../components/pagableComponent";
const orderHistoryRowHtml = require("./html/orderHistoryRow.html");
import SUCCESS_MODAL_TIMEOUT from "../../constants/index.js";
import { pillStatusClasses } from "../../utilities/filtersutil";
const statusPillBodyHtml = require('./html/statusPill.html');

run("#order-detail-page", ()=>{
  const orderDetailPage = $("#order-detail-page");
  const order = orderDetailPage.data("order");
  const pageReloadUrl = orderDetailPage.data("order-detail-page-reload-url");
  const generalErrorMessage = orderDetailPage.data("general-error-message");
  const packingSlipBtn = ".packing-slip-btn";
  const commercialInvoiceBtn = ".commercial-invoice-btn";
  const packingSlipUrl = orderDetailPage.data("package-slip-url");
  const commercialInvoiceUrl = orderDetailPage.data("commercial-invoice-url");
  const cancelBackorderUrl = orderDetailPage.data("cancel-backorder-url");
  const isCancelEnable = orderDetailPage.data("is-cancel-enable");
  const schedulerInterval = orderDetailPage.data("scheduler-interval");
  const releasedDate = orderDetailPage.data("ord-released-date");
  const holdDate = orderDetailPage.data("ord-hold-date");
  const selfFulfillUrl = orderDetailPage.data("self-fulfill-url");
  const selfFulfillShipWithFedExUrl = orderDetailPage.data("self-fulfill-shipwithfedex-url");
  const selfFulfillShipWith3rdPartyUrl = orderDetailPage.data("self-fulfill-shipwith3rdparty-url");
  const cancelReasonUrl = orderDetailPage.data("get-cancel-reason-url");
  const cancelOrderUrl = orderDetailPage.data("cancel-order-url");
  const releaseOrderUrl = orderDetailPage.data("release-order-url");
  const createRmaReturnUrl = orderDetailPage.data("create-rma-return-url");
  const selfFulfillDate = orderDetailPage.data("self-fulfill-date");
  const downloadFedexShippingLabelUrl = orderDetailPage.data("download-fedex-shipping-label-url");
  let targetCancelOriId = null;
  const datTimeFormat = "MM/DD/YYYY hh:mm A";
  const dateFormat = "MM/DD/YYYY";
  const resubmitUrl =  orderDetailPage.data("resubmit-url");
  let oriItemIds = [];
  const markExceptionClosedUrl = orderDetailPage.data("mark-exception-closed-url");
  const resolveExceptionUrl = orderDetailPage.data("resolve-exception-url");
  const cssNotesModalTitle = orderDetailPage.data("css-notes-modal-title");
  const cssNotesModalBtnTxt = orderDetailPage.data("css-notes-modal-btn-txt");
  const resolutionNotesEl  = $('.resolution-notes');
  const activateProductModalCall = $(".activate-product-business-exception-modal-call");
  const activateProductModal = $("#activate-product-business-exception-modal");
  const activateProductConfirm = activateProductModal.find(".confirm-btn");
  const productDetailPageUrl= orderDetailPage.data("product-detail-page-url");
  const updateProductDetailPageUrl= orderDetailPage.data("update-product-detail-page-url");
  const updateProductModalCall = $(".update-product-business-exception-modal-call");
  const updateProductModal = $("#update-product-business-exception-modal");
  const updateProductConfirm = updateProductModal.find(".confirm-btn");

  const setInternationalShippingModal = $("#set-international-shipping-for-retailer-modal");
  const setInternationalShippingConfirm = setInternationalShippingModal.find(".confirm-btn");

  const viewOrderDetailURL =  orderDetailPage.data("order-detail-url");
  const portletNamespace =  orderDetailPage.data("portlet-namespace");
  const editOrderUrl = orderDetailPage.data("edit-order-url");
  const editOrderBtn = orderDetailPage.find(".edit-order");
  const orderActions = orderDetailPage.data("order-actions");
  const loadMoreOrderActionsUrl = orderDetailPage.data("loadmore-actions-url");
  const orderLastEditedDate = orderDetailPage.data("order-last-edited-date");
  const shipOrderUrl =  orderDetailPage.data("shiporder-url");
  const downloadFileByDocIdUrl = orderDetailPage.data("download-by-doc-url");
  const downloadFileUrl = orderDetailPage.data("download-file-url");

  let resolveExceptionModal = $(render(
    modalHtml, {
      title: cssNotesModalTitle,
      leftAlignTitle: true,
      body: cssNotesModalBodyHtml,
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn resolve-exception-modal-confirm">'+ cssNotesModalBtnTxt +'</a>'
    }
  ));

  let editErrorModal = $(render(
    modalHtml, {
      title: "Edit Order",
      leftAlignTitle: true,
      body: renderErrorModalPill(),
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
    }
  ));

  let editBackOrderedModal = $(render(
    modalHtml, {
      title: "Edit Order",
      leftAlignTitle: true,
      body: renderBackOrderedModal(),
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
    }
  ));

  let editManualHoldModal = $(render(
    modalHtml, {
      title: "Edit Order",
      leftAlignTitle: true,
      body: renderOrderHeldModal(),
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
    }
  ));

  let editCustomHeldModal = $(render(
    modalHtml, {
      title: "Edit Order",
      leftAlignTitle: true,
      body: renderCustomHeldModal(),
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
    }
  ));

  let editChannelHeldModal = $(render(
    modalHtml, {
      title: "Edit Order",
      leftAlignTitle: true,
      body: renderChannelHeldModal(),
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
    }
  ));
  
  let editPortalHeldModal = $(render(
    modalHtml, {
      title: "Edit Order",
      leftAlignTitle: true,
      body: renderPortalHeldModal(),
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
    }
  ));

  function renderPortalHeldModal(){
      return render(editPortalHeldOrderModal, {
        statusPill: renderPillForModal(order.ordStatus)
      });
  }

  function renderChannelHeldModal(){
    return render(editChannelHeldOrderModal, {
      statusPill: renderPillForModal(order.ordStatus)
    });
  }

  function renderCustomHeldModal(){
    return render(editCustomHeldOrderModal, {
      statusPill: renderPillForModal(order.ordStatus)
    });
  }

  function renderOrderHeldModal() {
    return render(editHeldOrderModal, {
      statusPill: renderPillForModal(order.ordStatus)
    });
  }

  function renderBackOrderedModal(){
    return render(editBackOrderedOrderModal, {
      statusPill: renderPillForModal(order.ordStatus)
    });
  }

  function renderErrorModalPill(){
    return render(editErrorOrderModal, {
      statusPill: renderPillForModal(order.ordStatus)
    });
  }

  function renderPillForModal(status){
    let newRender;
    let statusPillClass = pillStatusClasses[status] || pillStatusClasses.default;
    let statusText = "Order " + status;
    return newRender = render(
      statusPillBodyHtml, {
        statusText,
        statusPillClass
      }
    );
  }

  $('body').append(resolveExceptionModal, editErrorModal, editBackOrderedModal, editCustomHeldModal, editPortalHeldModal, editChannelHeldModal, editManualHoldModal);

  $(".resolve-exception-modal-confirm").on('click', onResolveExceptionClick);

  function onResolveExceptionClick(e) {
    e.preventDefault();
    if($("form#cssNotesInputForm").valid()){
      submitModalFlow.showLoadingModal();
      $.ajax({
          url: resolveExceptionUrl,
          type: 'POST',
          dataType: 'TEXT',
          data: {
          notes: $(".resolution-notes").val(),
            exceptionId: resolveExceptionModal.data("currentExceptionId")
          },
          success: function(data) {
            if (data.match("Success")) {
              submitModalFlow.showSuccessModal();
              setTimeout(function() {
                location.href = pageReloadUrl;
              }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
            } else {
              submitModalFlow.showFailureModal();
            }
          },
          error: function() {
            submitModalFlow.hideAllModals();
          }
        });
    }
  }
    let cssNotesValidator = $("form#cssNotesInputForm").validate();


  $(document).on('click', '.close-exception', function(e) {
    e.preventDefault();
    const exceptionId = $(this).data('exception-id');
    $(this).closest('.exception-row').hide();
    closeException(exceptionId);
  });

  function closeException(exceptionId) {
    $.ajax({
      url: markExceptionClosedUrl,
      type: 'POST',
      dataType: 'TEXT',
      data: {
        exceptionId: exceptionId
      }
    });
  }

  $(document).on('click', '.resolve-exception-btn', function(e) {
	e.preventDefault();
    const exceptionId = $(this).data('exception-id');
	resolveException(exceptionId);
  });

  
  $(document).on('click', '.download-doc-row-btn', function(e) {
      e.preventDefault();
      const documentId = $(this).data('document-id');

      if(shallAllowClick(this)){
          downloadFiles([documentId], 'downloadByDocId');
      }
  });

  $('body').on('click', '.download-shipping-doc-btn', function(e){
    e.preventDefault();
    if(shallAllowClick(this)){       
      downloadFiles([order.ordOrderId], 'downloadByShpInfo');
    }
  });

  function downloadFiles(item, downloadSrc) {
    let downloadFileUri;
    let encodeDocId;
    if (downloadSrc == 'downloadByDocId'){
        encodeDocId=encodeURIComponent(item);
        downloadFileUri = `${downloadFileByDocIdUrl}&documentId=${encodeDocId}`;
    }else{
        encodeDocId=encodeURIComponent(item);
        downloadFileUri = `${downloadFileUrl}&orderId=${encodeDocId}`;
    }
    
    let formData = new FormData();
    formData.append("shpShipmentRow", "");
    submitModalFlow.showLoadingModal();
    $.ajax({
        url: downloadFileUri,
        type: 'POST',
        data: formData,
        enctype: 'multipart/form-data',
        processData: false,
        contentType: false,
        cache: false,
        success: downloadFileSuccess,
        error: downloadFileError
    });
  }

  function shallAllowClick(currentObj){
    return 	!($(currentObj).hasClass("disabled"));
  }

  function downloadFileSuccess(data) {
    if (isPresent(data)) {
        $.each(JSON.parse(data), function (key, value) {
            if (value.contentType == "atd") {
                value.contentType = "txt";
            }
            downloadFile(value.contentType, value.fileName, value.content);
        });
    } else {
        setTimeout(function () {
            submitModalFlow.hideAllModals();
            submitModalFlow.showFailureModal();
        }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
    }
  }

  function downloadFileError() {
    submitModalFlow.showFailureModal();
    setTimeout(function () {
        submitModalFlow.hideAllModals();
        submitModalFlow.showFailureModal();
    }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
  }

  function downloadFile(mimeType, fileName, data) {
    var a = document.createElement('a');
    if (window.URL && window.Blob && ('download' in a) && window.atob) {
        // Do it the HTML5 compliant way
        var blob = base64ToBlob(data, mimeType);
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    }
    submitModalFlow.hideAllModals();
  }

  function base64ToBlob(base64, mimetype, slicesize) {
    if (!window.atob || !window.Uint8Array) {
        // The current browser doesn't have the atob function. Cannot continue
        return null;
    }
    mimetype = "application/" + mimetype || '';
    slicesize = slicesize || 512;
    var bytechars = atob(base64);
    var bytearrays = [];
    for (var offset = 0; offset < bytechars.length; offset += slicesize) {
        var slice = bytechars.slice(offset, offset + slicesize);
        var bytenums = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            bytenums[i] = slice.charCodeAt(i);
        }
        var bytearray = new Uint8Array(bytenums);
        bytearrays[bytearrays.length] = bytearray;
    }
    return new Blob(bytearrays, { type: mimetype });
  }

  $(document).on('click', '.activate-product-business-exception-modal-call', function(e) {
    let itemId=$(this).data("item-id");
    let productDetailUrl = productDetailPageUrl+"&itemId="+itemId;
    activateProductConfirm.attr("href",productDetailUrl);
    activateProductModal.modal("show");

  });

  $(document).on('click', '.update-product-business-exception-modal-call', function(e) {
    let itemId=$(this).data("item-id");
    let productDetailUrl = updateProductDetailPageUrl+"&itemId="+itemId;
    updateProductConfirm.attr("href",productDetailUrl);
    updateProductModal.modal("show");

  });

  updateProductConfirm.on('click', function(e){
    $("#update-product-business-exception-modal").modal("close");
  });

  activateProductConfirm.on('click', function(e){
    $("#activate-product-business-exception-modal").modal("close");
  });

  function createDetailLink(ordOrderId) {
    return `${viewOrderDetailURL}&${portletNamespace}orderId=${ordOrderId}`;
  }



  function resolveException(exceptionId) {
    resolveExceptionModal.modal('show');
    resolveExceptionModal.data("currentExceptionId", exceptionId);
    // resolveExceptionFlow.showConfirmModal();
  }


  $(document).on('click', '.view-notes', function(e) {
    e.preventDefault();
    const notes = $(this).data('resolution-notes');
	const resolvedTime = $(this).data('resolution-time');
	const resolvedBy = $(this).data('resolved-by');
    openNotesModal(notes,resolvedTime,resolvedBy);
  });

  function openNotesModal(notes,resolvedTime,resolvedBy) {

	const modalBody = render(
		cssReadNotesModalBodyHtml,
		{
		  date : resolvedTime,
		  css : resolvedBy,
		  notes: notes
		},
	)

    const notesModal = $(render(
      modalHtml,
      {
        title: 'Notes',
        leftAlignTitle: true,
        body: modalBody,
        topCloseBtn: true,
        footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Close</a>'
      }
    ));
    notesModal.modal("show");
  }

  $(".ord-detail-remove-item-btn").on('click', function(e) {
    e.preventDefault();
    const targetOriId = $(this).closest(".product-sku-container").data("ori-id");
    $("#prd-does-not-exit-msg-"+targetOriId).hide();
    $("#mark-deletion-msg-"+targetOriId).show();
    oriItemIds.push(targetOriId);
  });

  const markDeletionSubmit = new SubmitModalFlow({
    confirmModalTitle: 'Remove Product From Order',
    // confirmModalSubtitle: "Optional Subtitle",
    confirmModalBody: `<div class="q-pad-all-xl">
						Are you sure you want to remove this product from the order? Please resubmit this order once you remove this product.
					  </div>`,
    onConfirmClick: function(){
      // Show Loading Modal



      setTimeout(function() {
        markDeletionSubmit.showLoadingModal();
        markDeletionSubmit.showSuccessModal();
        markDeletionSubmit.hideAllModals();
      }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
      // call ajax funtion here.
    }
  });


  markDeletionSubmit.init();

	const resubmitModal = new SubmitModalFlow({
		confirmModalTitle: 'Resubmit Order',
		// confirmModalSubtitle: "Optional Subtitle",
		confirmModalBody: `<div class="q-pad-all-xl">
								<div>
									<p class="q-marg-bottom-md">The order wil be resubmitted to the fulfilment network. If successful, the order being processing. if unsuccessful, the order will remain in an error status until the error has been resolved.</p>
									<div class="q-marg-top-md">
										<div class="pretty-well pw-border-rad pw-pad-md">
											If resubmitting doesnt work, contact your dedicated customer sucess specialist
										</div>
									</div>
								</div>
							</div>`,
		confirmModalBtnText: 'Resubmit Order',
		onConfirmClick: function(){
			// Show Loading Modal
			  resubmitModal.showLoadingModal();
      // call ajax funtion here.
      $("#removeOriIdText").val(JSON.stringify(oriItemIds));
      reSubmitOrder({url: resubmitUrl, success: submitOrderSuccess, error: submitOrderError});
    }
  });



  resubmitModal.init();

  function reSubmitOrder({url, success, error}){
    $.ajax({
      data:  $("#resubmit-order").serialize(),
      url: url,
      type: 'POST',
      success: success,
      error: error
    });
  }

  function submitOrderSuccess(orderId){
    if(orderId){
      EditChecker.setPageClean();
      resubmitModal.showSuccessModal();
      setTimeout(function() {
        location.href=createDetailLink(orderId);
      }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
    }
  }


  function submitOrderError(){
    resubmitModal.showFailureModal();
  }


  $("#resubmit-ord-btn").on('click', function() {
    resubmitModal.showConfirmModal();
  });

  const submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();

  onLoad();




  /*
  onload functionality
  */
  function onLoad() {
    const ordStatus = order.ordStatus;
    const gracePeriod = order.ordGracePeriod;
    let orderCreatedDate = "";

    if(isCancelEnable !== true) {
      hideCancelOrderBtn();
    }

    if(isPresent(order.ordCreatedDate)){

      //var date = new Date(order.ordCreatedDate); // date object will not work with IE need to manipulate manually.
      //let orderDate =  new Date(Date.parse(order.ordCreatedDate));
      $("#order-details-datereceived").text(order.ordCreatedDate + " ET");
    }

    if(isPresent(order.ordTargetCompletionDate)){
      //var date = new Date(order.ordCreatedDate); // date object will not work with IE need to manipulate manually.
      let orderDate =  new Date(order.ordTargetCompletionDate); //timestamp
      $("#target-completion-date").text(moment(orderDate).format(dateFormat));
    }

    if((ordStatus === "Held" || (ordStatus === "Released" && order.ordReleasedBy === "hc-scheduler"))
    && isPresent(gracePeriod) && gracePeriod > 0 && order.ordHoldBy == null) {
      populateGraceperiod(order.ordCreatedDate, ordStatus, gracePeriod, orderLastEditedDate);
    }

    if(ordStatus === "Released") {
      populateReleaseDate();
    }

    if(ordStatus === "Held" && isPresent(order.ordHoldBy)) {
      populateHoldDate();
    }

    if(ordStatus === "Hold Pending") {
      populateHoldPendingMsg();
    }

    if(ordStatus === "Pending") {
      populatePendingStatusMsg();
    }

    if(ordStatus === "Self Fulfill") {
      populateSelfFulfillDate();
    }

    if(ordStatus === "Partially Released") {
      populateReleaseDate();
    }

    //self ful-fill
    $('#self-fulfilled-shipped-by-fedex').hide();
    $('#self-fulfilled-shipped-by-3rdparty').hide();
    if(order.ordSelfFulfilled && order.ordStatus == "Shipped") {

      let orderDate =  new Date(Date.parse(order.ordCreatedDate));
      $(".self-fulfilled-date").text(moment(orderDate.toUTCString()).format(datTimeFormat) + " ET");
      if(order.orderShipments != null && order.orderShipments.length > 0){
        if(order.orderShipments[0].orsCarrier.toLowerCase() == 'fedex'){ //Shipped  by Fedex
          $('#self-fulfilled-shipped-by-fedex').show();
          $('#self-fulfilled-shipped-by-3rdparty').hide();
        }else{ //Shipped  by 3rd Party
          $('#self-fulfilled-shipped-by-fedex').hide();
          $('#self-fulfilled-shipped-by-3rdparty').show();
          $('#packages-section').hide();
          $('#tracking-information').hide();
        }
      }

      $.each(order.orderShipments, function(index, orderShipment) {
        if(orderShipment.orsCarrier.toLowerCase() != 'fedex'){
          $('#list-tracking-numbers')
          .append(
            $('<p class="q-no-marg-bottom">')
            .html($('<a href="'+orderShipment.orsUrl+'" target="_new">').text(orderShipment.orsTrackingNumber))
          );
        }
      });
    }

  }

  function populateSelfFulfillDate() {
    $("#order-status-message").html("Self-Fulfilled:");
    $("#order-status-message-time").html(selfFulfillDate);
  }

  function populatePendingStatusMsg() {
    $("#order-status-message-time").html("Refresh this page in a few moments to get an updated status.");
  }

  function populateHoldPendingMsg() {
    $("#order-status-message").html("Awaiting Fulfillment Center Confirmation");
  }

  function populateReleaseDate() {
    $("#order-status-message").html("Released:");
    $("#order-status-message-time").html(releasedDate);
  }

  function populateHoldDate() {
    $("#order-status-message").html("Held:");
    $("#order-status-message-time").html(holdDate);
  }

  function populateGraceperiod(orderCreatedDate, ordStatus, gracePeriod, orderLastEditedDate) {
    let gpHours = parseInt(gracePeriod/60);
    let gpMinutes = gracePeriod%60;
    let dateToUseForScheduledReleaseCalculation;
    if(isPresent(orderLastEditedDate)){
      dateToUseForScheduledReleaseCalculation=orderLastEditedDate;
    }else{
      dateToUseForScheduledReleaseCalculation=orderCreatedDate;
    }
    let scheduledReleaseDate = moment(dateToUseForScheduledReleaseCalculation, datTimeFormat).add(gracePeriod, 'm');
    let scheduledRelease = scheduledReleaseDate.format(datTimeFormat) + " ET";
    let t = scheduledReleaseDate - new Date();
    $("#actualGracePeriod-wrapper i").removeClass('hide');

    if(t > 0 && ordStatus === "Held") {

      if(order.ordChannelType.match("Manual")){
        $("#actualGracePeriod").html(`<strong>Grace Period:</strong> Portal Orders (${_.escape(gpHours)} hr ${_.escape(gpMinutes)}  mins)`);
      } else{

        $("#actualGracePeriod").html(`<strong>Grace Period:</strong> Channel Orders (${_.escape(gpHours)} hr ${_.escape(gpMinutes)} mins)`);
      }

      $("#order-status-message").html("Scheduled Release:");
      $("#order-status-message-time").html(scheduledRelease);

      $("#countdown-time-wrapper").show();
      let timeinterval = setInterval(function() {
        let timeObj = getTimeRemaining(scheduledReleaseDate);

        if(timeObj.total > 0) {
          let countDownTime = "";
          if(timeObj.days > 0) {
            countDownTime = `${_.escape(formatTime(timeObj.days))} Days ${_.escape(formatTime(timeObj.hours))} : ${_.escape(formatTime(timeObj.minutes))} : ${_.escape(formatTime(timeObj.seconds))}`;
          } else {
            countDownTime = `${_.escape(formatTime(timeObj.hours))} : ${_.escape(formatTime(timeObj.minutes))} : ${_.escape(formatTime(timeObj.seconds))}`;
          }
          $("#countdown-time").html(countDownTime);
          $(".countdown-time-modal").html(countDownTime);
        }else{
          clearInterval(timeinterval);
          location.href = pageReloadUrl; //refresh current page
        }
      }, 1000);
    } else if (ordStatus === 'Released' && order.ordReleasedBy == 'hc-scheduler') {
      $("#actualGracePeriod").html("<strong>Grace Period: Expiration</strong>");
    } else if(order.ordStatus === 'Held' && order.ordReleasedBy == null) {
      $("#actualGracePeriod").html("<strong>Grace Period: Expired, this order will be released shortly.</strong>");
    }
  }

  /*
  onload functionality emd.
  */

  function hideReleaseOrderBtn() {
    $(".order-detail-release-order-btn").hide();
  }

  function hideSelfFulfillBtn() {
    $(".order-self-fulfill").hide();
  }

  function hideCancelOrderBtn() {
    $(".order-detail-cancel-order-btn").hide();
  }

  /*
  *cancel order button functionality
  */
  $(".order-detail-cancel-order-btn").click(function() {
    $.ajax({
      url: cancelReasonUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        orderId: order.ordOrderId
      },
      success: function(data){
        if(data.response === "success") {
          $("#modalCancelOrder").attr("disabled", true);
          $("#order-detail-cancel-reason").val('0');
          $("#cancelModal").modal("show");
          emptyCurrentResonList();
          fillReasonList(data.reasonList);
        }
      }
    });
  });

  $(".ship-order-btn").click(function() {
    submitModalFlow.showLoadingModal();
    $.ajax({
      url: shipOrderUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        orderId: order.ordOrderId
      },
      success: function(data){
        if(data.response === "Success") {
          submitModalFlow.showSuccessModal();
          setTimeout(function() {
            location.href = pageReloadUrl;
          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        }else {
          submitModalFlow.showFailureModal();
        }
      }
    });
  });


  function emptyCurrentResonList() {
    const reasonOptions = $("#order-detail-cancel-reason").find("option");
    _.each(reasonOptions, function(val, key) {
      if(key != 0){
        val.remove();
      }
    });
  }

  function fillReasonList(data) {
    _.each(data, function(val, key) {
      let option = $('<option />');
      option.attr('value', key).text(val);
      $("#order-detail-cancel-reason").append(option);
    });
  }

  $( "#order-detail-cancel-reason").change(function() {
    $("#modalCancelOrder").attr("disabled", false);
  });

  $("#modalCancelOrder").click(function(){
    const reason = $('#order-detail-cancel-reason :selected').text();
    const value = $('#order-detail-cancel-reason :selected').val();
    cancelOrder(reason, value);
  });

  function cancelOrder(reason, value) {
    submitModalFlow.showLoadingModal();
    $.ajax({
      url: cancelOrderUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        orderId: order.ordOrderId,
        reason: reason,
        value: value
      },
      success: function(data){
        if(data.response === "success") {
          submitModalFlow.showSuccessModal();
          setTimeout(function() {
            location.href = pageReloadUrl;
          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        }
      }
    });
  }

  /**
  *cancel order button functionality end
  */

  $("#confirmModalClose").click(function() {
    location.href = pageReloadUrl;
  });

  /**
  *release order button functionality
  */
  $('.order-detail-release-order-btn').click(function() {
    $("#releaseModal").modal("show");
  });

  $('#releaseModalSubmitBtn').click(function(){
    releaseOrder();
  });

  function releaseOrder() {
    submitModalFlow.showLoadingModal();
    $.ajax({
      url: releaseOrderUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        orderId: order.ordOrderId
      },
      success: function(data){
        if(data.response === "success") {
          submitModalFlow.showSuccessModal();
          setTimeout(function() {
            location.href = pageReloadUrl;
          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        }
      }
    });
  }

  /**
  *release order button functionality end
  */

  /**
  *create rma return functionality
  */

  $(".create-a-return-rma").click(function() {
    $.ajax({
      url: createRmaReturnUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        orderId: order.ordOrderId
      },
      success: onSuccessCreateRmaReturn,
      error: function(){
      }
    });
  });

  function onSuccessCreateRmaReturn(data) {
    let formwithRmaDetails = $('<form></form>');
    formwithRmaDetails.attr("method", "post");
    formwithRmaDetails.attr("action", data.requestUrl);

    let returnRequestJson = $('<input></input>');
    returnRequestJson.attr("type", "hidden");
    returnRequestJson.attr("name", "returnRequest");
    returnRequestJson.attr("value", JSON.stringify(data));

    formwithRmaDetails.append(returnRequestJson);

    $(document.body).append(formwithRmaDetails);
    formwithRmaDetails.submit();
  }

  /**
  *create rma return functionality end
  */


  /**
  *cancel backorder functionality
  */

  $(".order-bundle-cancel-backorder").click(function(e) {
    e.preventDefault();
    targetCancelOriId = $(this).closest(".product-sku-container").data("ori-id");
    $("#cancelBundleBackorderModal").modal("show");
  });

  $(".order-cancel-backorder").click(function(e) {
    e.preventDefault();
    targetCancelOriId = $(this).closest(".product-sku-container").data("ori-id");
    $("#cancelBackorderModal").modal("show");
  });

  $("#cancelBackorderSubmitBtn").click(function() {
    cancelBackorderItems();
  });

  $("#cancelBundleBackorderSubmitBtn").click(function() {
    cancelBackorderItems();
  });

  function cancelBackorderItems() {
    $.ajax({
      url: cancelBackorderUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        orderId: order.ordOrderId,
        oriId: targetCancelOriId
      },
      success: function(data){
        if(data.status === "Success") {
          submitModalFlow.showSuccessModal();
          setTimeout(function() {
            location.href = pageReloadUrl;
          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        } else {
        }
      },
      error: function(){
      }
    });
  }
  /**
  *cancel backorder functionality end.
  */

  $(packingSlipBtn).click(function(e) {
    e.preventDefault();
    let packingSlipWindow  = window.open(packingSlipUrl,'packingSlipWindow');
    packingSlipWindow.document.title = "packing-slip";
  });

  $(commercialInvoiceBtn).click(function(e) {
    e.preventDefault();
    let commercialSlipWindow = window.open(commercialInvoiceUrl,'commercialInvoiceWindow');
    commercialSlipWindow.document.title = "commercial-invoice";
  });

  $(".tracking-url").click(function(e) {
    e.preventDefault();
    const trackingUrl = $(this).closest(".package-tracking-link").data("package-tracking-url");
    window.open(trackingUrl, '_blank');
  });

  function getTimeRemaining(scheduledReleaseDate) {
    let today = getESTDate(new Date());
    let t = scheduledReleaseDate - today;
    let seconds = Math.floor( (t/1000) % 60 );
    let minutes = Math.floor( (t/1000/60) % 60 );
    let hours = Math.floor( (t/(1000*60*60)) % 24 );
    let days = Math.floor( t/(1000*60*60*24) );
    return {
      'total': t,
      'days': days,
      'hours': hours,
      'minutes': minutes,
      'seconds': seconds
    };
  }

  function formatTime(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  /**
  *Self Ful-fillment functionality start.
  */

  $(".order-self-fulfill").click(function(e) {
    e.preventDefault();
    if ($(this).hasClass('disabled')) return;
    $("#selfFulfillModal").modal("show");
  });

  $("#selfFulfillSubmitBtn").click(function(e) {
    submitModalFlow.showLoadingModal();
    e.preventDefault();
    $.ajax({
      url: selfFulfillUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        orderId: order.ordOrderId
      },
      success: function(data){
        if(data.response === "success") {
          submitModalFlow.showSuccessModal();
          setTimeout(function() {
            location.href = pageReloadUrl;
          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        }
      },
      error: function(){
      }
    });
  });

  $("#fedExShippingLabel").click(function(e) {
    e.preventDefault();
    window.open(downloadFedexShippingLabelUrl,'labelWindow');
  });

  // Ship With Fedex
  const shipFedExOpenBtn = $(".ship-fedex-open-btn");
  shipFedExOpenBtn.click(onShipFedExOpenBtnClick);

  const shipFedExModal = shipFedExModalFactory({
    onShipFedExBtnValidClick: function(){
      const data = shipFedExModal.getAllFormData();
      postShipWithFedEx(data);
    }
  });
  const shipFedExModalFactoryEl = shipFedExModal.getElement();

  function postShipWithFedEx(data){
    submitModalFlow.showLoadingModal();
    data.orderId = order.ordOrderId;
    data[`boxes`] = JSON.stringify(data.boxes);
    $.ajax({
      url: selfFulfillShipWithFedExUrl,
      type: 'POST',
      dataType: 'JSON',
      data: data,
      success: function(data){
        if(data.response === "success") {
          submitModalFlow.showSuccessModal();
          setTimeout(function() {
            location.href = pageReloadUrl;
          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        }
      },
      error: function(){
      }
    });
  }

  function onShipFedExOpenBtnClick(e){
    e.preventDefault();
    shipFedExModal.showModal();
  }
  // END

  // Ship with Fedex - Third Party
  const shipThirdPartyOpenBtn = $(".ship-third-party-open-btn");
  shipThirdPartyOpenBtn.click(onShipThirdPartyOpenBtnClick);

  const shipThirdPartyModal = shipThirdPartyModalFactory({
    onShipThirdPartyBtnValidClick: function(){
      const data = shipThirdPartyModal.getAllFormData();
      postShipWithThirdParty(data);
    }
  });

  function postShipWithThirdParty(data){
    submitModalFlow.showLoadingModal();
    data.orderId = order.ordOrderId;
    data[`trackingNumbers`] = JSON.stringify(data.trackingNumbers);
    $.ajax({
      url: selfFulfillShipWith3rdPartyUrl,
      type: 'POST',
      dataType: 'JSON',
      data: data,
      success: function(data){
        if(data.response === "success") {
          submitModalFlow.showSuccessModal();
          setTimeout(function() {
            location.href = pageReloadUrl;
          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        }
      },
      error: function(){
      }
    });
  }

  function onShipThirdPartyOpenBtnClick(e){
    e.preventDefault();
    shipThirdPartyModal.showModal();
  }

   //validateOnAllSelectChanges();
  // END: Real Code

  /**
  *Self Ful-fillment functionality end.
  */
  const pagableOrderHistory = new PagableComponent({
    dataContainer: '.data-container-for-order-history',
    pagingContainer: '.paging-container-for-order-history',
    data: orderActions,
    showData: function (row) {
      return render(orderHistoryRowHtml, {
        updatedOn: row.cmaActionDate,
        updatedBy: row.cmaActionBy,
        statusPill: statusPillRender(row.cmaAction),
        description: row.cmaStatus
      });
    },
    onFetch: function (page, pageSize) {
      pagableOrderHistory.showLoadingOverlay();
      setTimeout(() => {
        doAjax({url: loadMoreOrderActionsUrl, success: loadMoreOrders, error: errorFun, data:prepareDataToSendController(order.ordOrderId, page, pageSize)});
      },SUCCESS_MODAL_TIMEOUT);
    }
  });

  function loadMoreOrders(data){
    let orders = data.content;
    pagableOrderHistory.setData(orders);
    pagableOrderHistory.hideLoadingOverlay();
  }

  function errorFun(data){
    pagableOrderHistory.hideLoadingOverlay();
  }

  function prepareDataToSendController(orderId, page, pageSize){
    let data={
      page: page,
      pageSize: pageSize,
      orderId: orderId
    }
    return data;
  }
  pagableOrderHistory.init();

  function statusPillRender(statusText) {
    let newRender;
    let statusPillClass = pillStatusClasses[statusText] || pillStatusClasses.default;
    return newRender = render(
      statusPillBodyHtml, {
        statusText,
        statusPillClass
      }
    );
  }

  editOrderBtn.on("click", function(e){
    e.preventDefault();
    if(order.ordStatus == "Error"){
      showEditOrderModalError();
    }
    if(order.ordStatus == "Backordered"){
      showEditOrderModalBackordered();
    }
    if(order.ordStatus == "Held"){
      if(order.ordChannelType != "Manual" && order.ordChannelType != "Manual (Bulk)" && order.ordChannelType != "API" && order.ordChannelType != "BigCommerce"){
        showEditChannelHeldModal();
      }else{
        if(order.ordReleaseType == "Hold Indefinitely"){
          showEditOrderManualHeldModal();
        }
        else if(order.ordReleaseType == "Scheduled Release"){
          showEditCustomHeldModal();
        }
        else if(order.ordReleaseType == "Internal Order Grace Period" || order.ordReleaseType == "Channel Order Grace Period"){
          showEditPortalHeldModal();
        }
      }
    }
  });

  $('.edit-order-modal').on("click", function(e){
    e.preventDefault();
    if(shallAllowClick(this)){
      let orderIdForEdit=order.ordOrderId;
      location.href = `${editOrderUrl}&${portletNamespace}orderIdForEdit=${orderIdForEdit}`;
    }
  });

  function showEditOrderModalError(){
    editErrorModal.modal('show');
  }

  function showEditOrderModalBackordered(){
    editBackOrderedModal.modal('show');
  }

  function showEditOrderManualHeldModal(){
    editManualHoldModal.modal('show');
  }

  function showEditCustomHeldModal(){
    editCustomHeldModal.modal('show');
  }

  function showEditChannelHeldModal(){
    editChannelHeldModal.modal('show');
  }
  
  function showEditPortalHeldModal(){
    editPortalHeldModal.modal('show');
  }

});



// WEBPACK FOOTER //
// ./src/pages/order/details.js